angular.module('uti.skayo.onlinesale').controller('TextController', function ($scope, $routeParams, $http) {

    gettextCatalog.getString('Transaction pending payment ');

});